module.exports = __webpack_public_path__ + "img/odf-pop-up-modal-2026.328d051.avif";